import * as React from 'react';
import { Stack } from '@mui/material'
import type { ReactNode } from 'react'
import { ScrollableContent } from './ScrollableContent.js'

interface Props {
  top: ReactNode
  bottom?: ReactNode
}

export function SplitLayout(props: Props) {
  const { top, bottom = null } = props

  return (
    <Stack height="100%" width="100%">
      <ScrollableContent>{top}</ScrollableContent>
      {bottom}
    </Stack>
  )
}
